import React, { useEffect, useState } from "react";
import AuthPage from "./AuthPage";

const API = "https://api.haymestasarim.com/api";

export default function AyarlarPage() {
  const token = localStorage.getItem("user_token");

const [tab, setTab] = useState("profile");





  const [bank, setBank] = useState({
    name: "",
    iban: "",
    account_name: "",
  });



const [profile, setProfile] = useState({
  name: "",
  email: "",
  refCode: "",
  paketAdi: "",
  paketDurum: "",
});
const [paketler, setPaketler] = useState([]);


const [passwords, setPasswords] = useState({
  current: "",
  next: "",
  confirm: "",
});





  /* ================= EFFECTS ================= */







useEffect(() => {
  if (!token) return;

  fetch(`${API}/profile/paketler`, {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then(r => r.json())
    .then(d => {
      // 🔥 backend { data: [...] } veya direkt [...] dönebilir
      if (Array.isArray(d)) {
        setPaketler(d);
      } else if (Array.isArray(d?.data)) {
        setPaketler(d.data);
      } else {
        setPaketler([]);
      }
    })
    .catch(() => setPaketler([]));
}, [token]);


useEffect(() => {
  if (!token) return;

  fetch(`${API}/profile/overview`, {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then(r => r.json())
    .then(d => {
      if (!d) return;

      setProfile({
        name: d.name || "",
        email: d.email || "",
        refCode: d.ref_code || "",
        paketAdi: d.paket_adi || "",
        paketDurum: d.paket_durum || "",
      });
    })
    .catch(() => {});
}, [token]);




  useEffect(() => {
    if (!token) return;

    fetch(`${API}/profile/bank`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(r => r.json())
      .then(d => d && setBank(d))
      .catch(() => {});
  }, [token]);

  /* ================= ACTIONS ================= */

const saveBank = async () => {
  const iban = bank.iban.replace(/\s+/g, "");

  if (!/^TR\d{22,24}$/.test(iban)) {
    alert("❌ Geçerli bir TR IBAN giriniz");
    return;
  }

  await fetch(`${API}/profile/bank`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      ...bank,
      iban,
    }),
  });

  alert("✅ Banka bilgileri kaydedildi");
};



const changePassword = async () => {
  if (!passwords.current || !passwords.next) {
    alert("Mevcut ve yeni şifre zorunlu");
    return;
  }

  if (passwords.next.length < 6) {
    alert("Yeni şifre en az 6 karakter olmalıdır");
    return;
  }

  if (passwords.next !== passwords.confirm) {
    alert("Yeni şifreler eşleşmiyor");
    return;
  }

  try {
    const res = await fetch(`${API}/auth/change-password`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        currentPassword: passwords.current,
        newPassword: passwords.next,
      }),
    });

    const data = await res.json();

    if (!res.ok) {
      alert(data.error || "Şifre değiştirilemedi");
      return;
    }

    alert("✅ Şifre başarıyla değiştirildi");

    // inputları temizle
    setPasswords({ current: "", next: "", confirm: "" });

  } catch (err) {
    console.error(err);
    alert("❌ Sunucu hatası");
  }
};


  /* ================= AUTH ================= */

  if (!token) {
    return <AuthPage onAuth={() => window.location.reload()} />;
  }

  /* ================= UI ================= */

  return (
    <div style={styles.page}>
      <h1 style={styles.title}>Ayarlar</h1>
      <p style={styles.subtitle}>
        Hesap ayarlarınızı ve tercihlerinizi yönetin
      </p>

      {/* TABS */}
      <div style={styles.tabs}>
        <Tab label="Profil" v="profile" a={tab} s={setTab} />
        <Tab label="Şifreyi Değiştir" v="password" a={tab} s={setTab} />
        <Tab label="Banka Bilgileri" v="bank" a={tab} s={setTab} />
      </div>

      {/* CONTENT */}
      <div style={styles.card}>

{tab === "profile" && (
  <>
<h2>Profil Bilgilerim</h2>
<p style={styles.desc}>
  Bu bilgiler sistem tarafından otomatik oluşturulur ve değiştirilemez.
</p>




<div style={{ ...styles.infoRow, flexDirection: "column", alignItems: "stretch", gap: 10 }}>
  <div style={{ fontWeight: 700 }}>Paketim</div>

  <div style={{ display: "flex", flexDirection: "column", gap: 10, width: "100%" }}>
    {paketler.length > 0 ? (
      paketler.map((p, i) => {
        const baslangic = p.baslangic_tarihi ? new Date(p.baslangic_tarihi) : null;
        const bitis = p.bitis_tarihi ? new Date(p.bitis_tarihi) : null;
        const gun = bitis ? Math.ceil((bitis - new Date()) / (1000 * 60 * 60 * 24)) : null;

        return (
          <div
            key={i}
            style={{
              width: "100%",
              padding: "12px 14px",
              borderRadius: 12,
              background: p.durum?.toLowerCase().includes("onay") ? "#ecfdf5" : "#fff7ed",
              border: "1px solid #e5e7eb",
              display: "flex",
              flexDirection: "column",
              gap: 6
            }}
          >
            <div style={{ fontWeight: 800 }}>
              {getPaketText(p.paket_adi, p.durum)}
            </div>

            {baslangic && bitis && (
              <div style={{ fontSize: 13, color: "#475569" }}>
                📅 {baslangic.toLocaleDateString("tr-TR")} {" → "} {bitis.toLocaleDateString("tr-TR")}
              </div>
            )}

    {gun !== null && (
  <>
    {gun > 0 && (
      <div style={badgeStyle(gun)}>
        {gun} gün kaldı
      </div>
    )}

    {gun <= 0 && p.durum?.toLowerCase().includes("onay") && (
      <div style={expiredStyle}>
        🔵 Bu paket daha yüksek pakete geçildiği için sona erdi
      </div>
    )}

    {gun <= 0 && !p.durum?.toLowerCase().includes("onay") && (
      <div style={expiredStyleRed}>
        🔴 Paket süresi doldu. Tekrar satın alabilirsiniz.
      </div>
    )}
  </>
)}



          </div>
        );
      })
    ) : (
      <div
        style={{
          width: "100%",
          padding: 12,
          borderRadius: 12,
          background: "#fef2f2",
          border: "1px solid #fecaca",
          fontWeight: 700
        }}
      >
        {getPaketText(profile.paketAdi, profile.paketDurum)}
      </div>
    )}
  </div>
</div>





<div style={styles.infoRow}>
  <span>Ad</span>
  <strong>{profile.name || "—"}</strong>
</div>


<div style={styles.infoRow}>
  <span>E-posta</span>
  <strong>{profile.email || "—"}</strong>
</div>


   <div style={styles.refBox}>
  <span>Referans Kodum</span>
  <strong>{profile.refCode || "—"}</strong>
</div>

    <div style={styles.infoNote}>
      ℹ️ Profil bilgileri güvenlik nedeniyle panel üzerinden değiştirilemez.
    </div>
  </>
)}


        {tab === "password" && (
          <>
            <h2>Şifreyi Değiştir</h2>
            <p style={styles.desc}>
              Hesabınızı güvende tutmak için şifrenizi güncelleyin
            </p>

            <Input
              label="Güncel Şifre"
              type="password"
              value={passwords.current}
              onChange={v => setPasswords(p => ({ ...p, current: v }))}
            />

            <Input
              label="Yeni Şifre"
              type="password"
              value={passwords.next}
              onChange={v => setPasswords(p => ({ ...p, next: v }))}
              hint="En az 6 karakter"
            />

            <Input
              label="Yeni Şifreyi Onayla"
              type="password"
              value={passwords.confirm}
              onChange={v => setPasswords(p => ({ ...p, confirm: v }))}
            />

            <button style={styles.primaryBtn} onClick={changePassword}>
              Şifreyi Değiştir
            </button>
          </>
        )}

        {tab === "bank" && (
          <>
            <h2>Banka Bilgileri</h2>

            <Input
              label="Banka Adı"
              value={bank.name}
              onChange={v => setBank(b => ({ ...b, name: v }))}
            />
       <Input
  label="IBAN"
  value={bank.iban}
  onChange={v =>
    setBank(b => ({
      ...b,
      iban: formatIBAN(v),
    }))
  }
  hint="TR otomatik eklenir, boşluklar sistem tarafından ayarlanır"
/>




<Input
  label="Hesap Sahibi (Ad Soyad)"
  value={bank.account_name}
  onChange={v => setBank(b => ({ ...b, account_name: v }))}
  hint="Banka hesabındaki isim soyisim"
 />


            <button style={styles.primaryBtn} onClick={saveBank}>
              Kaydet
            </button>
          </>
        )}




      </div>
    </div>
  );
}

/* ================= COMPONENTS ================= */
function getPaketText(paketAdi, paketDurum) {
  if (!paketAdi) {
    return "🔴 Henüz bir paket satın almadınız";
  }

  if (!paketDurum) {
    return "🔴 Henüz bir paket satın almadınız";
  }

  // 🔥 NORMALİZE ET (KRİTİK NOKTA)
  const durum = String(paketDurum).toLowerCase();

  // 🟡 BEKLEMEDE (admin + backend tüm varyasyonlar)
  if (
    durum === "beklemede" ||
    durum === "pending" ||
    durum === "requested" ||
    durum.includes("bekle")
  ) {
    return "🟡 Paket Onay Bekliyor";
  }

  // 🟢 ONAYLANDI
  if (durum === "onaylandı" || durum === "onaylandi" || durum === "approved") {
    return `🟢 ${paketAdi} (Onaylandı)`;
  }

  return `${paketAdi} (${paketDurum})`;
}



function formatIBAN(value) {
  // sadece harf + rakam
  let v = value.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();

  // TR sabit
  if (!v.startsWith("TR")) {
    v = "TR" + v.replace(/^TR/, "");
  }

  // TR + max 24 rakam
  v = v.slice(0, 26);

  // 4’erli gruplama
  return v.replace(/(.{4})/g, "$1 ").trim();
}



function Tab({ label, v, a, s }) {
  return (
    <button
      onClick={() => s(v)}
      style={{
        ...styles.tab,
        background: a === v ? "#2563eb" : "#f1f5f9",
        color: a === v ? "#fff" : "#0f172a",
      }}
    >
      {label}
    </button>
  );
}

function Input({ label, value, onChange, type = "text", hint }) {
  return (
    <div style={{ marginBottom: 16 }}>
      <label style={styles.label}>{label}</label>
      <input
        type={type}
        value={value}
        onChange={e => onChange(e.target.value)}
        style={styles.input}
      />
      {hint && <small style={styles.hint}>{hint}</small>}
    </div>
  );
}
/* ================= STYLES ================= */

const styles = {
  page: { padding: 32 },
  title: { fontSize: 28, fontWeight: 800 },
  subtitle: { color: "#64748b", marginBottom: 24 },

  tabs: { display: "flex", gap: 10, marginBottom: 20 },
  tab: {
    padding: "10px 16px",
    borderRadius: 10,
    border: "none",
    cursor: "pointer",
    fontWeight: 600,
  },

  card: {
    background: "#fff",
    padding: 28,
    borderRadius: 18,
    boxShadow: "0 10px 30px rgba(0,0,0,.06)",
  },

  desc: { color: "#64748b", marginBottom: 20 },

  label: { display: "block", fontWeight: 600, marginBottom: 6 },
  input: {
    width: "100%",
    padding: 12,
    borderRadius: 10,
    border: "1px solid #e5e7eb",
  },
  hint: { color: "#64748b", fontSize: 12 },

  primaryBtn: {
    marginTop: 20,
    background: "linear-gradient(135deg,#f97316,#2563eb)",
    color: "#fff",
    padding: "12px 20px",
    border: "none",
    borderRadius: 12,
    fontWeight: 700,
    cursor: "pointer",
  },

  leaderBox: {
    padding: 18,
    borderRadius: 14,
    border: "1px solid #e5e7eb",
    marginBottom: 16,
  },

  leaderEmpty: {
    fontSize: 14,
    color: "#475569",
  },

  motivation: {
    marginTop: 20,
    padding: 16,
    background: "#fff7ed",
    borderRadius: 14,
    color: "#9a3412",
    fontWeight: 600,
  },

  infoNote: {
    marginTop: 16,
    padding: 14,
    background: "#eff6ff",
    borderRadius: 12,
    color: "#1e3a8a",
    fontWeight: 600,
  },

  refBox: {
    marginTop: 16,
    padding: 14,
    borderRadius: 12,
    background: "linear-gradient(135deg,#eff6ff,#fff7ed)",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontWeight: 700,
  },

  refLabel: {
    color: "#475569",
    fontSize: 13,
  },

  refCode: {
    color: "#2563eb",
    fontSize: 18,
    letterSpacing: 1,
  },

  infoRow: {
    display: "flex",
    justifyContent: "space-between",
    padding: "12px 0",
    borderBottom: "1px solid #e5e7eb",
    fontSize: 15,
  },
};


/* ================= EXTRA BADGE STYLES ================= */

const expiredStyle = {
  padding: "4px 10px",
  borderRadius: 20,
  fontSize: 12,
  fontWeight: 800,
  background: "#dbeafe",
  color: "#1e40af"
};

const expiredStyleRed = {
  padding: "4px 10px",
  borderRadius: 20,
  fontSize: 12,
  fontWeight: 800,
  background: "#fecaca",
  color: "#991b1b"
};

const badgeStyle = (gun) => ({
  alignSelf: "flex-start",
  padding: "4px 10px",
  borderRadius: 20,
  fontSize: 12,
  fontWeight: 800,
  background:
    gun <= 3 ? "#fecaca" :
    gun <= 7 ? "#fde68a" :
    gun <= 30 ? "#bfdbfe" : "#dcfce7",
  color:
    gun <= 3 ? "#991b1b" :
    gun <= 7 ? "#92400e" :
    gun <= 30 ? "#1e40af" : "#166534"
});

/* =====================================================
   MOBILE RESPONSIVE OVERRIDE
===================================================== */

if (typeof window !== "undefined") {
  const isMobile = window.innerWidth < 768;

  if (isMobile) {

    styles.page.padding = 16;

    styles.tabs.flexDirection = "column";
    styles.tabs.gap = 8;

    styles.card.padding = 18;

    styles.title.fontSize = 22;

    styles.infoRow.flexDirection = "column";
    styles.infoRow.alignItems = "flex-start";
    styles.infoRow.gap = 4;

    styles.refBox.flexDirection = "column";
    styles.refBox.alignItems = "flex-start";
    styles.refBox.gap = 6;

    styles.primaryBtn.width = "100%";

    styles.leaderBox.padding = 14;

  }
}

